export default __webpack_public_path__ + "static/media/md-card-bg-da-python.0e70d8e7.png";